import '../assets/tailwind.css';
import '../assets/styles.scss';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
const appName = import.meta.env.VITE_APP_NAME || 'LAY7 cloud';

import setupI18n, { loadLocaleMessages } from '@/plugins/i18n';
const i18n = setupI18n();

import WebsiteLayout from "@/layouts/WebsiteLayout.vue";

import editable from "./directives/editable.js";
import editableItems from "@/directives/editableItems.js";

createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: async (name) => {
        let component = await resolvePageComponent(
            `./pages/${name}.vue`,
            import.meta.glob('./pages/**/*.vue'),
        )
        component.default.layout = WebsiteLayout
        return component
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(PrimeVue, {
                theme: {
                    preset: definePreset(Aura, {
                        semantic: {
                            primary: {
                                50: '{surface.50}',
                                100: '{surface.100}',
                                200: '{surface.200}',
                                300: '{surface.300}',
                                400: '{surface.400}',
                                500: '{surface.500}',
                                600: '{surface.600}',
                                700: '{surface.700}',
                                800: '{surface.800}',
                                900: '{surface.900}',
                                950: '{surface.950}'
                            },
                            colorScheme: {
                                light: {
                                    primary: {
                                        color: '{primary.950}',
                                        contrastColor: '#ffffff',
                                        hoverColor: '{primary.800}',
                                        activeColor: '{primary.700}'
                                    },
                                    highlight: {
                                        background: '{primary.950}',
                                        focusBackground: '{primary.700}',
                                        color: '#ffffff',
                                        focusColor: '#ffffff'
                                    }
                                },
                                dark: {
                                    primary: {
                                        color: '{primary.50}',
                                        contrastColor: '{primary.950}',
                                        hoverColor: '{primary.200}',
                                        activeColor: '{primary.300}'
                                    },
                                    highlight: {
                                        background: '{primary.50}',
                                        focusBackground: '{primary.300}',
                                        color: '{primary.950}',
                                        focusColor: '{primary.950}'
                                    }
                                }
                            }
                        }
                    }),
                    options: {
                        primary: 'noir',
                        surface: 'slate',
                        darkModeSelector: '.app-dark'
                    }
                }
            });

        app.directive('editable', editable);
        app.directive("editable-items", editableItems);
        app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
